module.exports = __webpack_public_path__ + "static/media/feedback.946ec232.svg";